export default __webpack_public_path__ + "static/media/Ruang-Kelas-dark.e84a801d.svg";